import { render } from "./DetectionImageViewer.vue?vue&type=template&id=b79eef58&ts=true"
import script from "./DetectionImageViewer.vue?vue&type=script&lang=ts"
export * from "./DetectionImageViewer.vue?vue&type=script&lang=ts"

import "./DetectionImageViewer.vue?vue&type=style&index=0&id=b79eef58&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__